import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'

@Component({
  selector: 'dmmp-form-step-number',
  templateUrl: './step-number.component.html',
})
export class StepNumberComponent implements OnInit {
  @Input() stepActive
  @Input() fieldSteps
  @Output() stepPrev: EventEmitter<any> = new EventEmitter<any>()

  constructor() {
  }

  ngOnInit() {
  }
}
